import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import Top from "./table-top.js";
import TableHeader from "./table-header.js";
import TableBody from "./table-body.js";
import Bottom from "./table-bottom.js";
import TableGrid from "./table-grid.js";
import QVirtualScroll from "../virtual-scroll/QVirtualScroll.js";
import QLinearProgress from "../linear-progress/QLinearProgress.js";
import getTableMiddle from "./get-table-middle.js";
import { commonVirtPropsList } from "../../mixins/virtual-scroll.js";
import DarkMixin from "../../mixins/dark.js";
import ListenersMixin from "../../mixins/listeners.js";
import Sort from "./table-sort.js";
import Filter from "./table-filter.js";
import Pagination from "./table-pagination.js";
import RowSelection from "./table-row-selection.js";
import RowExpand from "./table-row-expand.js";
import ColumnSelection from "./table-column-selection.js";
import FullscreenMixin from "../../mixins/fullscreen.js";
import cache from "../../utils/cache.js";
var commonVirtPropsObj = {};
commonVirtPropsList.forEach(function (p) {
  commonVirtPropsObj[p] = {};
});
export default Vue.extend({
  name: 'QTable',
  mixins: [DarkMixin, ListenersMixin, FullscreenMixin, Top, TableHeader, TableBody, Bottom, TableGrid, Sort, Filter, Pagination, RowSelection, RowExpand, ColumnSelection],
  props: _objectSpread(_objectSpread({
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rowKey: {
      type: [String, Function],
      default: 'id'
    },
    columns: Array,
    loading: Boolean,
    binaryStateSort: Boolean,
    iconFirstPage: String,
    iconPrevPage: String,
    iconNextPage: String,
    iconLastPage: String,
    title: String,
    hideHeader: Boolean,
    grid: Boolean,
    gridHeader: Boolean,
    dense: Boolean,
    flat: Boolean,
    bordered: Boolean,
    square: Boolean,
    separator: {
      type: String,
      default: 'horizontal',
      validator: function validator(v) {
        return ['horizontal', 'vertical', 'cell', 'none'].includes(v);
      }
    },
    wrapCells: Boolean,
    virtualScroll: Boolean
  }, commonVirtPropsObj), {}, {
    noDataLabel: String,
    noResultsLabel: String,
    loadingLabel: String,
    selectedRowsLabel: Function,
    rowsPerPageLabel: String,
    paginationLabel: Function,
    color: {
      type: String,
      default: 'grey-8'
    },
    titleClass: [String, Array, Object],
    tableStyle: [String, Array, Object],
    tableClass: [String, Array, Object],
    tableHeaderStyle: [String, Array, Object],
    tableHeaderClass: [String, Array, Object],
    cardContainerClass: [String, Array, Object],
    cardContainerStyle: [String, Array, Object],
    cardStyle: [String, Array, Object],
    cardClass: [String, Array, Object]
  }),
  data: function data() {
    return {
      innerPagination: Object.assign({
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: this.rowsPerPageOptions.length > 0 ? this.rowsPerPageOptions[0] : 5
      }, this.pagination)
    };
  },
  watch: {
    needsReset: function needsReset() {
      this.hasVirtScroll === true && this.$refs.virtScroll !== void 0 && this.$refs.virtScroll.reset();
    }
  },
  computed: {
    getRowKey: function getRowKey() {
      var _this = this;

      return typeof this.rowKey === 'function' ? this.rowKey : function (row) {
        return row[_this.rowKey];
      };
    },
    hasVirtScroll: function hasVirtScroll() {
      return this.grid !== true && this.virtualScroll === true;
    },
    needsReset: function needsReset() {
      var _this2 = this;

      return ['tableStyle', 'tableClass', 'tableHeaderStyle', 'tableHeaderClass', '__containerClass'].map(function (p) {
        return _this2[p];
      }).join(';');
    },
    filteredSortedRows: function filteredSortedRows() {
      var rows = this.data;

      if (this.isServerSide === true || rows.length === 0) {
        return rows;
      }

      var _this$computedPaginat = this.computedPagination,
          sortBy = _this$computedPaginat.sortBy,
          descending = _this$computedPaginat.descending;

      if (this.filter) {
        rows = this.filterMethod(rows, this.filter, this.computedCols, this.getCellValue);
      }

      if (this.columnToSort !== void 0) {
        rows = this.sortMethod(this.data === rows ? rows.slice() : rows, sortBy, descending);
      }

      return rows;
    },
    filteredSortedRowsNumber: function filteredSortedRowsNumber() {
      return this.filteredSortedRows.length;
    },
    computedRows: function computedRows() {
      var rows = this.filteredSortedRows;

      if (this.isServerSide === true) {
        return rows;
      }

      var rowsPerPage = this.computedPagination.rowsPerPage;

      if (rowsPerPage !== 0) {
        if (this.firstRowIndex === 0 && this.data !== rows) {
          if (rows.length > this.lastRowIndex) {
            rows = rows.slice(0, this.lastRowIndex);
          }
        } else {
          rows = rows.slice(this.firstRowIndex, this.lastRowIndex);
        }
      }

      return rows;
    },
    computedRowsNumber: function computedRowsNumber() {
      return this.isServerSide === true ? this.computedPagination.rowsNumber || 0 : this.filteredSortedRowsNumber;
    },
    nothingToDisplay: function nothingToDisplay() {
      return this.computedRows.length === 0;
    },
    isServerSide: function isServerSide() {
      return this.computedPagination.rowsNumber !== void 0;
    },
    cardDefaultClass: function cardDefaultClass() {
      return " q-table__card" + (this.isDark === true ? ' q-table__card--dark q-dark' : '') + (this.square === true ? " q-table--square" : '') + (this.flat === true ? " q-table--flat" : '') + (this.bordered === true ? " q-table--bordered" : '');
    },
    __containerClass: function __containerClass() {
      return "q-table__container q-table--".concat(this.separator, "-separator column no-wrap") + (this.grid === true ? ' q-table--grid' : this.cardDefaultClass) + (this.isDark === true ? " q-table--dark" : '') + (this.dense === true ? " q-table--dense" : '') + (this.wrapCells === false ? " q-table--no-wrap" : '') + (this.inFullscreen === true ? " fullscreen scroll" : '');
    },
    containerClass: function containerClass() {
      // do not trigger a refresh of the table when the loading status is changed
      return this.__containerClass + (this.loading === true ? ' q-table--loading' : '');
    },
    virtProps: function virtProps() {
      var _this3 = this;

      var props = {};
      commonVirtPropsList.forEach(function (p) {
        props[p] = _this3[p];
      });

      if (props.virtualScrollItemSize === void 0) {
        props.virtualScrollItemSize = this.dense === true ? 28 : 48;
      }

      return props;
    }
  },
  render: function render(h) {
    var child = [this.__getTopDiv(h)];
    var data = {
      staticClass: this.containerClass
    };

    if (this.grid === true) {
      child.push(this.__getGridHeader(h));
    } else {
      Object.assign(data, {
        class: this.cardClass,
        style: this.cardStyle
      });
    }

    child.push(this.__getBody(h), this.__getBottomDiv(h));

    if (this.loading === true && this.$scopedSlots.loading !== void 0) {
      child.push(this.$scopedSlots.loading());
    }

    return h('div', data, child);
  },
  methods: {
    requestServerInteraction: function requestServerInteraction() {
      var _this4 = this;

      var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$nextTick(function () {
        _this4.$emit('request', {
          pagination: prop.pagination || _this4.computedPagination,
          filter: prop.filter || _this4.filter,
          getCellValue: _this4.getCellValue
        });
      });
    },
    resetVirtualScroll: function resetVirtualScroll() {
      this.hasVirtScroll === true && this.$refs.virtScroll.reset();
    },
    __getBody: function __getBody(h) {
      var _this5 = this;

      if (this.grid === true) {
        return this.__getGridBody(h);
      }

      var header = this.hideHeader !== true ? this.__getTHead(h) : null;

      if (this.hasVirtScroll === true) {
        var topRow = this.$scopedSlots['top-row'];
        var bottomRow = this.$scopedSlots['bottom-row'];
        var virtSlots = {
          default: this.__getVirtualTBodyTR(h)
        };

        if (topRow !== void 0) {
          var topContent = h('tbody', topRow({
            cols: this.computedCols
          }));
          virtSlots.before = header === null ? function () {
            return [topContent];
          } : function () {
            return [header].concat(topContent);
          };
        } else if (header !== null) {
          virtSlots.before = function () {
            return header;
          };
        }

        if (bottomRow !== void 0) {
          virtSlots.after = function () {
            return h('tbody', bottomRow({
              cols: _this5.computedCols
            }));
          };
        }

        return h(QVirtualScroll, {
          ref: 'virtScroll',
          props: _objectSpread(_objectSpread({}, this.virtProps), {}, {
            items: this.computedRows,
            type: '__qtable',
            tableColspan: this.computedColspan
          }),
          on: cache(this, 'vs', {
            'virtual-scroll': this.__onVScroll
          }),
          class: this.tableClass,
          style: this.tableStyle,
          scopedSlots: virtSlots
        });
      }

      return getTableMiddle(h, {
        staticClass: 'scroll',
        class: this.tableClass,
        style: this.tableStyle
      }, [header, this.__getTBody(h)]);
    },
    scrollTo: function scrollTo(toIndex, edge) {
      if (this.$refs.virtScroll !== void 0) {
        this.$refs.virtScroll.scrollTo(toIndex, edge);
        return;
      }

      toIndex = parseInt(toIndex, 10);
      var rowEl = this.$el.querySelector("tbody tr:nth-of-type(".concat(toIndex + 1, ")"));

      if (rowEl !== null) {
        var scrollTarget = this.$el.querySelector('.q-table__middle.scroll');
        var offsetTop = rowEl.offsetTop;
        var direction = offsetTop < scrollTarget.scrollTop ? 'decrease' : 'increase';
        scrollTarget.scrollTop = offsetTop;
        this.$emit('virtual-scroll', {
          index: toIndex,
          from: 0,
          to: this.pagination.rowsPerPage - 1,
          direction: direction
        });
      }
    },
    __onVScroll: function __onVScroll(info) {
      this.$emit('virtual-scroll', info);
    },
    __getProgress: function __getProgress(h) {
      return [h(QLinearProgress, {
        staticClass: 'q-table__linear-progress',
        props: {
          color: this.color,
          dark: this.isDark,
          indeterminate: true,
          trackColor: 'transparent'
        }
      })];
    }
  }
});